import gql from "graphql-tag"

export default gql`

  mutation importStart($id: String!){
    importStart(id: $id)
  }
`